import type { ReactNode } from 'react';
import { Link } from 'react-router-dom';

/**
 * Minimal branded shell for the vet portal. Calm, clinical-feeling layout —
 * vet is reading medical records, not booking a service.
 */
export function VetShell({ children }: { children: ReactNode }) {
  return (
    <div className="min-h-[100dvh] bg-zinc-50 text-zinc-900">
      <header className="border-b border-zinc-200 bg-white">
        <div className="mx-auto flex max-w-5xl items-center justify-between px-6 py-4">
          <Link to="/" className="text-lg font-semibold tracking-tight">
            <span className="text-[#004AAD]">Kennel</span> Vet Portal
          </Link>
          <nav className="flex items-center gap-6 text-sm text-zinc-600">
            <Link to="/" className="hover:text-zinc-900">
              Pets
            </Link>
            <Link to="/sign-out" className="hover:text-zinc-900">
              Sign out
            </Link>
          </nav>
        </div>
      </header>
      <main className="mx-auto max-w-5xl px-6 py-8">{children}</main>
      <footer className="mx-auto max-w-5xl px-6 py-6 text-xs text-zinc-500">
        Read-only access to medical records shared with you by pet owners. The owner can revoke
        access at any time.
      </footer>
    </div>
  );
}
